import { APPLY_FORM_ENDPOINT } from "../../components/common/siteLinks";

// Google Apps Script accepts roughly 50MB per request and base64 adds ~33%,
// so these limits keep every submission comfortably under it.
export const FILE_LIMITS = {
  maxFiles: 10,
  maxFileSize: 5 * 1024 * 1024,
  maxTotalSize: 20 * 1024 * 1024,
  extensions: ["pdf", "jpg", "jpeg", "png", "doc", "docx"],
};

export const OTHER_COUNTRY = "Other";
export const NO_ENGLISH_TEST = "Not taken yet";

export const resolveCountry = (choice, other) =>
  choice === OTHER_COUNTRY ? other.trim() : choice;

const readAsBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(",")[1] || "");
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export async function submitApplication(form, files) {
  if (!APPLY_FORM_ENDPOINT) {
    throw new Error("APPLY_FORM_ENDPOINT is not set in siteLinks.js");
  }

  const documents = await Promise.all(
    files.map(async (file) => ({
      name: file.name,
      type: file.type || "application/octet-stream",
      data: await readAsBase64(file),
    }))
  );

  const hasTest = form.englishTest && form.englishTest !== NO_ENGLISH_TEST;
  const payload = {
    fullName: form.fullName.trim(),
    whatsapp: form.whatsapp.trim(),
    email: form.email.trim(),
    address: form.address.trim(),
    education: form.education.map((row) => ({
      level: row.level,
      marks: row.marks.trim(),
      year: row.year.trim(),
    })),
    preferredCountry: resolveCountry(form.country, form.countryOther),
    studyLevel: form.studyLevel,
    fieldOfStudy: form.fieldOfStudy,
    courses: form.courses.trim(),
    englishTest: form.englishTest,
    englishScore: hasTest ? form.englishScore.trim() : "",
    englishTestDate: hasTest ? form.englishTestDate : "",
    additionalInfo: form.additionalInfo.trim(),
    website: form.website,
    documents,
  };

  // A plain-text body keeps this a "simple" CORS request, which Apps Script
  // web apps require (they can't answer preflight requests).
  const response = await fetch(APPLY_FORM_ENDPOINT, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  const result = await response.json().catch(() => null);

  if (!response.ok || !result || !result.ok) {
    throw new Error((result && result.error) || `HTTP ${response.status}`);
  }
}
